import { joinInfoSegments, URLs } from '@orcar/common-d2c';
import { useBusinessProfile } from '@/hooks/useSiteProfile';
import * as S from '../styles';

type CompanyInfoSectionProps = {
  isOrcar?: boolean;
  isMobile?: boolean;
};

const CompanyInfoSection = ({ isOrcar, isMobile }: CompanyInfoSectionProps) => {
  const profile = useBusinessProfile();
  const lines = [
    joinInfoSegments(
      [
        profile.tradeName && { text: profile.tradeName },
        profile.registrationNumber && {
          text: `사업자등록번호 : ${profile.registrationNumber}`,
        },
        profile.representative && { text: `대표자: ${profile.representative}` },
      ],
      isMobile,
    ),
    joinInfoSegments(
      [
        profile.mailOrderNumber && {
          text: `통신판매업신고 : ${profile.mailOrderNumber}`,
        },
        profile.address && {
          text: `주소 : ${profile.address}`,
          breakOnMobile: true,
        },
      ],
      isMobile,
    ),
    joinInfoSegments(
      [
        profile.phone && { text: `TEL : ${profile.phone}` },
        profile.fax && { text: `FAX : ${profile.fax}` },
        profile.email && {
          text: `E-mail : ${profile.email}`,
          breakOnMobile: true,
        },
      ],
      isMobile,
    ),
  ];
  const INFO_MESSAGES = [
    '(주)오르카스튜디오는 패밀리렌트카 홈페이지의 개발 및 관리를 위탁 운영하고 있습니다.',
    '(주)오르카스튜디오는 통신판매중개자로서 통신판매의 거래당사자가 아닙니다.',
    '홈페이지 사용 중 기술적인 문제가 발생할 경우 오르카스튜디오 고객센터 070-8065-1999로 연락주시면 해결 도와드리겠습니다.',
  ];
  return (
    <S.CompanyInfoSectionWrapper isOrcar={isOrcar}>
      {isOrcar ? (
        <>
          <S.CompanyInfoInnerWrapper isMobile={isMobile}>
            <S.InfoContent isMobile={isMobile} isOrcar>
              오르카스튜디오 주식회사 | 대표자: 정재호 {isMobile ? <br /> : '|'}{' '}
              사업자등록번호 : 576-87-02239
            </S.InfoContent>
            <S.NavLink
              sub
              href={URLs.OUTLINK.BUSINESS_INFO}
              isMobile={isMobile}
              target='_blank'
            >
              사업자정보 조회
            </S.NavLink>
          </S.CompanyInfoInnerWrapper>
          <S.InfoContent isMobile={isMobile} isOrcar>
            주소 : 제주특별자치도 제성1길 28-1, 202호
          </S.InfoContent>
          <S.InfoContent isMobile={isMobile} isOrcar>
            통신판매신고 : 제2022-제주도두-0037호
          </S.InfoContent>
        </>
      ) : (
        <>
          {lines[0] && (
            <S.CompanyInfoInnerWrapper>
              <S.InfoContent isMobile={isMobile}>{lines[0]}</S.InfoContent>
            </S.CompanyInfoInnerWrapper>
          )}
          {lines.slice(1).map(
            (line, index) =>
              line && (
                <S.InfoContent key={index} isMobile={isMobile}>
                  {line}
                </S.InfoContent>
              ),
          )}
        </>
      )}
      {isOrcar && (
        <>
          {INFO_MESSAGES.map((item, idx) => (
            <S.InfoContent
              key={idx}
              margin={idx === 0 ? '10px 0 0 0' : ''}
              font={{
                'font-size': isMobile ? '12px' : '14px',
                'font-weight': '300',
                'line-height': isMobile ? '20px' : '25px',
              }}
              color='#8E8E8E'
            >
              {item}
            </S.InfoContent>
          ))}
        </>
      )}
    </S.CompanyInfoSectionWrapper>
  );
};

export default CompanyInfoSection;
